<template>
  <!-- 顶部操作 缩略图/列表切换 组件 author: zhangxiaofeng -->
  <div class="operation-module-type f-cb">
    <div class="sort__wrapper float_left" v-if="canSort && moduleType === 'thumbnail'">
      <w-dropdown @command="handlerAction">
        <div class="padding-0-5 cursor-pointer">排序<i class="r2-icon-nav_expand_more"></i></div>
        <w-dropdown-menu :visibleArrow="false" slot="dropdown">
          <w-dropdown-item v-for="(sortItem, idx) in sortDic" :key="idx" :command="{sortItem, idx}">
            {{sortItem.name}}
            <i v-if="+sortItem.sortType === 0" class="w-icon-paixugao color-green"></i>
            <i v-if="+sortItem.sortType === 1" class="w-icon-paixudi color-green"></i>
          </w-dropdown-item>
        </w-dropdown-menu>
      </w-dropdown>
      <!--<span>-->
      <!--<i class="w-icon-xiala1"></i>-->
      <!--排序-->
      <!--</span>-->
      <!--<ul>-->
      <!--<li v-for="(sortItem, idx) in sortDic" :key="idx" @click="changeFieldType(sortItem, idx)">-->
      <!--{{sortItem.name}}-->
      <!--<i v-if="+sortItem.sortType === 0" class="w-icon-paixugao"></i>-->
      <!--<i v-if="+sortItem.sortType === 1" class="w-icon-paixudi"></i>-->
      <!--</li>-->
      <!--</ul>-->
    </div>
    <i :class="['r2-icon-editor_format_list_bulleted icon-type-change cursor-pointer float_left', moduleType === 'list' ? 'active' : '']"
       :style="{ 'margin-left': !canSort ? '10px' : 0 }"
       @click="changeModuleType('list')" v-if="moduleType === 'thumbnail'"></i>
    <i :class="['r2-icon-device_widgets_outlined icon-type-change cursor-pointer float_left', moduleType === 'thumbnail' ? 'active' : '']"
      @click="changeModuleType('thumbnail')" v-if="moduleType === 'list'" style="paddingLeft: 10px;"></i>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .operation-module-type {
    color: #c2c2c2;

    .sort__wrapper {
      height: 32px;
      /*margin-right: 20px;*/
      display: inline-block;
      color: #666;
      position: relative;

      /*&:hover {*/
        /*& > ul {*/
          /*z-index: 10;*/
          /*visibility: visible;*/
        /*}*/
      /*}*/

      /*& > span {*/
        /*font-size: 13px;*/
        /*margin: 0px 5px;*/
        /*cursor: default;*/
      /*}*/

      /*& > ul {*/
        /*position: absolute;*/
        /*top: 30px;*/
        /*left: -10px;*/
        /*padding: 5px;*/
        /*border: 1px solid #c2c2c2;*/
        /*background: #fff;*/
        /*width: 100px;*/
        /*z-index: -1;*/
        /*visibility: hidden;*/

        /*li {*/
          /*padding-left: 20px;*/
          /*cursor: pointer;*/
          /*font-size: 14px;*/
        /*}*/

        /*i {*/
          /*margin-left: 0;*/
          /*font-size: 14px;*/
          /*margin-top: -3px;*/
          /*color: #b5d680;*/
        /*}*/
      /*}*/
    }

    i {
      font-size: 24px;
      &:hover {
        color: #79a7dc;
      }
    }

    [class*=" w-icon-"], [class^=w-icon-] {
      cursor: pointer;
      font-size: 20px;
    }

    .active {
      color: #79a7dc;
    }
  }
</style>
<script>
export default {
  name: 'OperationModuleType',
  props: {
    selectedType: { // 列表默认展示方式
      type: String,
      default: 'list'
    },
    sortFiledNames: { // 排序字段列表
      type: Array,
      default: () => {
        return [
          {key: 'name_chn', name: '工程名称', sortType: -1},
          {key: 'modifiedTime', name: '修改时间', sortType: -1},
          {key: 'size', name: '文件大小', sortType: -1}
        ]
      }
    },
    currentSort: { // 排序 改变时 "name_chn,0" (排序字段名称,排序方式) 0升序，1降序
      type: String,
      default: ''
    },
    // 是否 显示排序操作
    canSort: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      moduleType: 'list',
      sortDic: [],
      currentSortFiled: '',
      currentSortValue: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    handlerAction ({sortItem, idx}) {
      this.changeFieldType(sortItem, idx)
    },
    // 1. 初始化数据
    init () {
      if (this.selectedType === 'list' || this.selectedType === 'thumbnail') {
        this.moduleType = this.selectedType
      }
      this.sortFiledNames.forEach((item, idx) => {
        this.$set(this.sortDic, idx, item)
      })
      const arr = this.currentSort.split(',')
      if (arr.length > 1) {
        this.refreshSortList(arr[0], arr[1])
      }
    },
    // 2. 切换 列表/缩略图
    changeModuleType (type) {
      if (this.moduleType !== type) {
        this.moduleType = type
        this.$emit('change', {
          moduleType: this.moduleType,
          sortFieldName: this.currentSortFiled,
          sortType: this.currentSortValue
        })
      }
    },
    // 3. 排序方式改变时
    changeFieldType (item) {
      const value = +item.sortType === -1 ? 0 : ((+item.sortType + 1) % 2)
      this.refreshSortList(item.key, value)
      setTimeout(() => {
        this.$emit('change', {moduleType: this.moduleType, sortFieldName: item.key, sortType: value})
      }, 100)
    },
    // 3.1 刷新 排序箭头显示
    refreshSortList (key, value) {
      this.sortDic.map((item, idx) => {
        if (item.key === key) {
          this.$set(this.sortDic[idx], 'sortType', value)
          this.currentSortFiled = key
          this.currentSortValue = value
        } else {
          this.$set(this.sortDic[idx], 'sortType', -1)
        }
      })
    }
  },
  watch: {
    'currentSort': function () {
      const arr = this.currentSort.split(',')
      if (arr.length > 1) {
        this.refreshSortList(arr[0], arr[1])
      }
    }
  }
}
</script>
